import AddReviewPage from './add-review-page'

export default AddReviewPage
